export const ACCOUNT_ACTIONS = {
  SET_ACCOUNT: "SET_ACCOUNT",
  GET_ACCOUNT: "GET_ACCOUNT",
  SET_ACCOUNT_STATUS: "SET_ACCOUNT_STATUS",
};
